import { useState, useEffect } from 'react';

import { useThrottledCallback } from '@toolbox/hooks';

export const BREAKPOINTS = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
};

const getDeviceConfig = (width: number): string | undefined => {
  if (width < 320) {
    return BREAKPOINTS.xs;
  } else if (width >= 320 && width < 768) {
    return BREAKPOINTS.sm;
  } else if (width >= 768 && width < 1024) {
    return BREAKPOINTS.md;
  } else if (width >= 1024) {
    return BREAKPOINTS.lg;
  }
  return;
};

export const useBreakpoint = (): string | undefined => {
  const [brkPnt, setBrkPnt] = useState(() => getDeviceConfig(window.innerWidth));
  const calcInnerWidth = useThrottledCallback((): void => {
    setBrkPnt(getDeviceConfig(window.innerWidth));
  }, 200);

  useEffect(() => {
    window.addEventListener('resize', calcInnerWidth);
    return () => window.removeEventListener('resize', calcInnerWidth);
  }, [calcInnerWidth]);

  return brkPnt;
};
